import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';
import Select from '../../shared/reactSelect/select.component';
import FormHelpers from '../../shared/forms/formHelpers';
import WarningDialog from '../../shared/warningDialog.component';
import { OptionsPropType } from '../../shared/propTypes/common';

const initialFormStateFactory = () => ({
  adminJob: {
    value: '',
    isValid: true,
  },
});

const TIER_LABELS = {
  LOCAL_DEV: 'Dev',
  DEV: 'Dev',
  DEMO: 'Demo',
  STAGE: 'Stage',
  PROD: 'Prod',
};

class AdminJobsComponent extends PureComponent {
  static propTypes = {
    adminJobs: OptionsPropType,
    adminJobInProgressName: PropTypes.string,
    adminJobsFetching: PropTypes.bool.isRequired,
    runAdminJob: PropTypes.func.isRequired,
    tlsEnv: PropTypes.string,
  };

  state = {
    formData: initialFormStateFactory(),
    isFormDirty: false,
    isConfirmDialogVisible: false,
  };

  selectAdminJob = adminJob => {
    FormHelpers.selectProperty('adminJob', 'value', adminJob, this.setState.bind(this));
  };

  showConfirmDialog = () => {
    const { formData: { adminJob } } = this.state;
    if (adminJob && adminJob.value) {
      this.setState({ isConfirmDialogVisible: true });
    }
  };

  hideConfirmDialog = () => this.setState({ isConfirmDialogVisible: false });

  runAdminJob = () => {
    const { formData: { adminJob } } = this.state;
    this.hideConfirmDialog();
    if (adminJob && adminJob.value) {
      this.props.runAdminJob(adminJob.value);
    }
  };

  getConfirmMessage = () => {
    const { tlsEnv } = this.props;
    const { formData: { adminJob } } = this.state;
    const tierLabel = TIER_LABELS[tlsEnv] || tlsEnv;

    return `You are about to run ${adminJob.value} job which may change or delete ${tierLabel} data. Are you sure?`;
  };

  render() {
    const {
      adminJobs,
      adminJobsFetching,
      adminJobInProgressName,
    } = this.props;

    const { formData, isConfirmDialogVisible } = this.state;

    const formControlsDisabled = adminJobsFetching || !!adminJobInProgressName;

    return (
      <div className="form-group row align-items-center">
        <WarningDialog
          onCancel={this.hideConfirmDialog}
          onConfirm={this.runAdminJob}
          message={this.getConfirmMessage()}
          title="Warning!"
          dismissText="Cancel"
          submitText="Proceed"
          isVisible={isConfirmDialogVisible}
        />
        <label className="col-3 col-form-label">Admin Jobs</label>
        <div className="col-3">
          <Select
            options={adminJobs}
            onChange={this.selectAdminJob}
            value={formData.adminJob.value}
            clearable={false}
            disabled={formControlsDisabled}
          />
        </div>
        <div className="col-6">
          <Button
            type="button"
            kind="primary"
            size="lg"
            onClick={this.showConfirmDialog}
            isLoading={formControlsDisabled}
          >
            Run job
          </Button>
        </div>
      </div>
    );
  }
}

export default AdminJobsComponent;
